// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { oidcConfig } from '../app/oidc-config';

export const environment = {
  production: true,
  backendUrl: '', // Requests to internal backend address are established through nginx config
  frontendUrl: oidcConfig.frontend_url,
  oidc: oidcConfig.oidc
};
